<template>
  <div id="videomenu">
    <div class="section">
      <div class="intro">
        <!-- <div class="menulink portrait">
          <div class="menutitle">Læg venligst telefonen om på siden!</div>
        </div> -->

        <div class="menulink landscape">
          <div class="menu-outer-wrapper">
            <div class="headline1">
              <router-link to="/">{{ data.title }}</router-link>
            </div>
            <div class="menuwrapper">
              <router-link class="menuitem" :to="{ name: 'videomenu'}">
                <div id="video">VIDEO</div>
              </router-link>
              <router-link class="menuitem" :to="{ name: 'gallery'}">
                <div id="foto">FOTO</div>
              </router-link>
              <router-link class="menuitem" :to="{ name: 'kontakt'}">
                <div id="kontakt">KONTAKT</div>
              </router-link>
            </div>
          </div>

          <div v-for="(video, index) in data.videos" :key="index">
            <router-link :to="{ name: 'video', params: { id: index }}" :title="video.title">
              <img :src="video.thumb" />
              <div class="menutitle">{{video.title}}</div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const delay = t => new Promise(resolve => setTimeout(resolve, t));
export default {
  name: 'VideoMenu',
  props:  ["data"],
   async mounted() {
      if(!this.data.videos) await delay(350)
      const index = Math.floor(Math.random() * this.data.background_images.length) ;
      // document.querySelector(".intro").style.backgroundImage="url(" + this.data.background_images[index] + ")"
      document.querySelector("#fullpage").style.backgroundImage="url(" + this.data.background_images[index] + ")"
      // console.log(this.data)
  },
  methods: {
      nospace(value) {
         if (!value) return ''
         value = value.toString()
         return value.replace(/ /g,'')				
      }
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
